import { useState, useMemo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { PlusIcon, XIcon } from '@heroicons/react/solid';
import { TrashIcon } from '@heroicons/react/outline';
import useCategories from '../../hooks/useCategories';
import {
  deleteCategory as deleteCategoryService,
  postCategory as postCategoryService,
} from '../../redux/services/categoryService';

const Topics = () => {
  const categoryQuery = useCategories();
  const [isAdding, setIsAdding] = useState<Boolean>(false);
  const [newCategory, setNewCategory] = useState<string>('');

  const addSubject = async () => {
    await postCategoryService(newCategory);
    setNewCategory('');
    setIsAdding(false);
    categoryQuery.refetch();
  };

  const deleteCategory = async (id: string) => {
    await deleteCategoryService(id);
    categoryQuery.refetch();
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'label',
        headerName: 'Onderwerp',
        flex: 1,
        headerClassName: 'bg-gray-100',
      },
      {
        field: 'action',
        headerName: '',
        flex: 0.1,
        headerClassName: 'bg-gray-100',
        renderCell: (params) => {
          return (
            <button
              className="w-full flex justify-center"
              onClick={(e) => {
                e.stopPropagation();
                deleteCategory(params.row._id);
              }}
            >
              <TrashIcon className="w-5 text-gray-500 hover:text-gray-700" />
            </button>
          );
        },
      },
    ];
  }, []);

  if (!categoryQuery.isSuccess) {
    return <p>Loading...</p>;
  }

  return (
    <div className="flex-col space-y-3">
      {!categoryQuery.data.length && <p>Nog geen onderwerpen</p>}
      <DataGrid
        autoHeight
        rows={categoryQuery.data}
        columns={columns}
        getRowId={(row) => row._id}
        className="bg-white"
      />
      {isAdding ? (
        <div className="flex space-x-3">
          <input
            type={'text'}
            className="rounded-md"
            onChange={(e) => setNewCategory(e.target.value)}
          />
          <button
            className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
            onClick={() => {
              setIsAdding(false);
              setNewCategory('');
            }}
          >
            <XIcon className="w-5" />
            <p>Cancel</p>
          </button>
          <button
            className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
            onClick={addSubject}
            disabled={!newCategory.length}
          >
            <PlusIcon className="w-5" />
            <p>Toevoegen</p>
          </button>
        </div>
      ) : (
        <button
          className="flex text-white rounded-md p-2 bg-sky hover:bg-sky-dark space-x-1"
          onClick={() => setIsAdding(true)}
        >
          <PlusIcon className="w-5" />
          <p>Nieuwe categorie</p>
        </button>
      )}
    </div>
  );
};

export default Topics;
